import React from 'react';
import PropTypes from 'prop-types';

import { Accordion } from 'components/volta/accordion';

const propTypes = {
  target: PropTypes.element.isRequired,
  toggle: PropTypes.element.isRequired,
};

const ArrowToggle = ({ target, toggle }) => (
  <Accordion header={target}>
    {toggle}
  </Accordion>
);

ArrowToggle.propTypes = propTypes;
export default ArrowToggle;
